import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'caCurrency',
    standalone: false,
    pure: true
})
export class CurrencyPipe implements PipeTransform {
    private static readonly CURRENCY_BY_COUNTRY: Record<string, string> = {
        PL: 'PLN',
        CZ: 'CZK',
        SK: 'EUR',
        DE: 'EUR',
        FR: 'EUR',
        ES: 'EUR',
        NL: 'EUR',
        BE: 'EUR',
        AT: 'EUR',
        CH: 'CHF'
    };

    transform(amount: number | null | undefined, countryCode: string, languageCode?: string, options?: Intl.NumberFormatOptions): string {
        if (amount === null || amount === undefined || Number.isNaN(amount) || !countryCode) {
            return '';
        }
        countryCode = countryCode.toUpperCase();
        const currency = options?.currency || CurrencyPipe.CURRENCY_BY_COUNTRY[countryCode] || 'EUR';

        const locale = languageCode
            ? languageCode.includes('-') || languageCode.includes('_')
                ? languageCode.replace('_', '-')
                : `${languageCode}-${countryCode}`
            : undefined;

        const nf = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            currencyDisplay: 'symbol',
            ...options
        });

        return nf.format(amount);
    }
}
